import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

import { formatAssetStat } from 'sdk/utils/formatValues';
import { getPercent } from 'sdk/utils/assets';
import useAssetEvents from 'sdk/hooks/useAssetEvents';
import ChartPreview from 'modules/feed/components/Feed/ChartPreview';
import { StringConstant } from 'utils/Constants';
import styles from './FollowingAsset.module.scss'

type Props = {
  asset: any
}

export default function FollowingAsset({ asset }: Props) {
  const assetEventData = useAssetEvents(
    asset?.id,
    (asset?.category?.isNFT || asset?.category?.name === 'Crypto') ? '24H' : '1D',
    asset?.category?.name === StringConstant.ECONOMY, // 'Business and Money',
  )
  const [period, setPeriod] = useState((asset?.category?.isNFT || asset?.category?.name === 'Crypto') ? '24H' : '1D')
  const [selectedPrice, setSelectedPrice] = useState<{ price: number, time: string } | null>(null)
  const [isFall, setIsFall] = useState<boolean>(false)

  const lastPrice = asset?.latest_price?.price

  useEffect(() => {
    if (lastPrice && !selectedPrice?.price) {
      setSelectedPrice(lastPrice)
    }
  }, [lastPrice, selectedPrice])

  useEffect(() => {
    setPeriod((asset?.category?.isNFT || asset?.category?.name === 'Crypto') ? '24H' : '1D')
  }, [asset?.category?.isNFT])

  const pastDayPrice = asset?.quote?.previous_close
    ? Number(asset?.quote?.previous_close)
    : 0
  const oldPrice = period === '1D' ? (pastDayPrice || 0) : assetEventData?.data?.[0]?.close

  const deltaDefault = (lastPrice && oldPrice)
    ? lastPrice - oldPrice : 0

  useEffect(() => {
    setIsFall(deltaDefault < 0)
  }, [deltaDefault])

  const textColor = !isFall ? '#6FD964' : '#FF4D30'

  if (!asset) {
    return <span />
  }

  return (
    <div className={styles.assetRow}>
      <Link to={`/asset/${asset?.category?.name}/${asset.ticker}`} className={styles.assetImg}><img src={asset.icon} alt={asset.currency_name} /></Link>
      <Link to={`/asset/${asset?.category?.name}/${asset.ticker}`} className={styles.assetTitle}>
        {asset?.ticker}
        <span>
          (
          {asset.name}
          )
        </span>
      </Link>
      <div className={styles.assetIcon}>
        <ChartPreview
          className={styles.catGraphDemo}
          data={assetEventData.data || []}
          lastPrice={asset?.latest_price?.price}
          fall={isFall}
        />

      </div>
      <div className={styles.assetPrice} style={{ color: textColor }}>
        $
        {formatAssetStat(asset?.latest_price?.price, true)}
      </div>
      <div className={styles.assetPercent} style={{ color: textColor }}>
        {getPercent(asset)}
        %
      </div>
      <div className={styles.assetLast}>
        { asset?.stats?.['Market Cap'] ? `$${formatAssetStat(asset?.stats?.['Market Cap'], true)}` : ''}
        { asset?.stats_finance?.['Market cap'] ? `$${formatAssetStat(asset?.stats_finance?.['Market cap'], true)}` : ''}
      </div>
    </div>
  )
}
